export default "__VITE_ASSET__DT9Wg8Yg__"